import { useEffect, useRef, useState } from "react";

import { useMutationWithToaster } from "hooks";

import { deleteFormField, updateFormField } from "./taskFormQueries";

export function useFormFieldActions({ onUpdated, onDeleted }) {
  const mounted = useRef(false);
  const [isRunning, setRunning] = useState(null);

  const [updateFormFieldMutation] = useMutationWithToaster(updateFormField, {
    onDone: onUpdated,
  });

  const [deleteFormFieldMutation] = useMutationWithToaster(deleteFormField, {
    onDone: onDeleted,
  });

  useEffect(() => {
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const makeCallAbout = (id) => {
    return (action) => {
      return async (args) => {
        if (mounted.current) {
          setRunning(id);
          const resp = await action(args);
          if (mounted.current) setRunning(null);
          return resp;
        }
        return null;
      };
    };
  };

  const map = (f) => {
    const call = makeCallAbout(f.id);

    return {
      ...f,
      loading: isRunning === f.id,
      update: call((field) => {
        return updateFormFieldMutation(
          { id: f.id, field: field },
          {
            successMsg: "Form Field updated successfully.",
            defaultErrorMsg: "Failed to update form field.",
          }
        );
      }),
      delete: call(() => {
        return deleteFormFieldMutation(
          { fieldId: f.id },
          {
            successMsg: "Form Field deleted successfully.",
            defaultErrorMsg: "Failed to delete form field.",
          }
        );
      }),
    };
  };

  return map;
}

export default useFormFieldActions;
